<template>
  <div
    :class="['tw:relative', props.class]"
    :style="{ width: `${size}px`, height: `${size}px` }"
  >
    <!-- Platform icon pinned scaling proportionally and offset left. Do not use padding -->
    <img
      class="tw:absolute tw:left-[-25%] tw:top-0 tw:z-10 tw:w-[75%] tw:rounded-full"
      data-testid="social-profile-icon"
      :src="platformIcon"
    />

    <ImageIcon
      :alt="alt"
      data-testid="social-profile-image"
      fallback-icon="person"
      image-class="tw:rounded-full tw:z-0 tw:text-white tw:bg-denim-200"
      :size="`${size}px`"
      :src="profileUrl"
      v-bind="$attrs"
    />
  </div>
</template>

<script setup lang="ts">
import { getLocaleText } from "shared/boot/i18n";
import ImageIcon from "shared/components/base/ImageIcon.vue";
import { type Maybe } from "shared/types";

interface SocialProfileIconProps {
  alt?: string;
  class?: string;
  platformIcon: string;
  profileUrl: Maybe<string>;
  size?: number;
}

const props = withDefaults(defineProps<SocialProfileIconProps>(), {
  alt: () => getLocaleText("global.profile_picture"),
  class: "",
  platformIcon: "",
  profileUrl: undefined,
  size: 26,
});

defineOptions({ inheritAttrs: false });
</script>
